import { ModelSagres } from "../../model-sagres";
import { Contrato } from "./contrato";

export class ContratoCentralizado extends ModelSagres {
  IdContrato: number;
  NmOrgaoResp: string;
  NrContratoOrgaoResp: string;
  NrAnoContratoOrgaoResp: number;
  NrCnpjOrgaoResp: string;

  IdContratoNavigation: Contrato;
}
